import * as getters from "./getters";
import * as mutations from "./mutations";
import * as actions from "./actions";

const state = {
	guest: true,
	loggedIn: false,
	applicantData: {},
	applicantType: null,
	studentType: null,
	institutions: [],
	userSetup: false,
	continuingForm: false,
	email: null,
	userType: null
};

export default {
	state,
	getters,
	mutations,
	actions
};
